import React from "react";
import { Label } from "@/components/ui/label";
import { FieldError } from "@/components/FieldError";
import { Upload, CheckCircle2, X } from "lucide-react";

export const toB64 = (file) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(file); });

export const FileField = ({ label, testid, file, onPick, onClear, error }) => (
  <div aria-invalid={!!error}>
    <Label>{label}</Label>
    {!file ? (
      <label className={`mt-1.5 flex items-center gap-2 cursor-pointer rounded-lg border border-dashed px-3 py-2.5 text-sm text-muted-foreground hover:border-primary ${error ? "border-destructive" : "border-border"}`} data-testid={testid}>
        <Upload className="w-4 h-4" /> Carica file (PDF/JPG/PNG, max 6 MB)
        <input type="file" accept=".pdf,image/*" className="hidden" onChange={(e) => e.target.files?.[0] && onPick(e.target.files[0])} data-testid={`${testid}-input`} />
      </label>
    ) : (
      <div className="mt-1.5 flex items-center justify-between rounded-lg border border-teal-500/40 bg-teal-500/5 px-3 py-2.5 text-sm">
        <span className="flex items-center gap-2 truncate"><CheckCircle2 className="w-4 h-4 text-teal-500 shrink-0" /> {file.name}</span>
        <button type="button" onClick={onClear} className="text-muted-foreground hover:text-destructive" data-testid={`${testid}-clear`}><X className="w-4 h-4" /></button>
      </div>
    )}
    <FieldError msg={error} testid={`${testid}-error`} />
  </div>
);
